import $ from 'jquery';
import Util from 'root/module/util';
import Cache from 'root/cache';
import Modals from 'root/modals';
import View from 'view/base';

var Top_User_Chart = View.extend({
    is_loaded: false,

    events: {
        'click .user-id-lookup' : 'openUserIdentification',
        'click .view-more'      : 'viewMore'
    },

    dom_handlers: {
        openUserIdentification: function(e) {
            e.preventDefault();
            Modals.openUserIdentification($(e.currentTarget).data('val'));
        },

        viewMore: function(e) {
            e.preventDefault();

            this.$el.find('tr').show();
            this.$el.find('.view-more').parents('tr:first').remove();
        }
    },

    initialize: function(chart_data) {
        this.chart_data = chart_data;
        this.listenTo(Cache.user_identification, 'remove', this.render);
    },

    load: function(user_identifications) {
        this.is_loaded = true;

        Cache.app.request({
            action: 'user_identification/search',
            data: {
                identification: user_identifications
            },
            success: (response) => {
                Cache.user_identification.add(response.data);
                this.render();
            }
        });
    },

    render: function() {
        var html  = '';
        var limit = 5;
        var size  = this.chart_data.length;
        var total = 0;
        var count = 0;

        if (size) {
            var empty_ids = [];

            this.chart_data.forEach((data) => {
                var model = Cache.user_identification.get(data.user_identification);

                if (!model) {
                    empty_ids.push(data.user_identification);
                }
            });

            // check for is_loaded to prevent infinite loop
            if (empty_ids.length && !this.is_loaded) {
                // some user ids haven't been loaded
                // load them before render
                this.load(empty_ids);

                html = '<div class="loader" style="padding:80px 24px;"></div>';
            } else {
                html +=
                '<table class="medium">' +
                '<tr>' +
                    '<th>User</th>' +
                    '<th width="50%">Feedback</th>' +
                '</tr>';

                this.chart_data.forEach((data) => {
                    total += parseInt(data.feedback_total, 10);
                });

                this.chart_data.forEach((data) => {
                    var model = Cache.user_identification.findWhere({identification: data.user_identification});

                    if (model) {
                        count++;

                        var percentage = 0;

                        if (total) {
                            percentage = data.feedback_total / total * 100;
                        }

                        html += '<tr' + (count > limit  ? ' style="display:none;"' : '') + '>' +
                                    '<td>' +
                                        '<img class="user-32 float-left" src="' + Util.gravatar(model.get('email'), 24, model.get('display_name')) + '">' +
                                        '<div class="margin-left-48">' +
                                            '<a href="#" class="user-id-lookup badge-id margin-bottom-4" data-val="' + model.escape('identification') + '">' + Util.htmlEntities(model.get('identification')) + '</a>' +
                                            (model.get('display_name') ?
                                            '<div class="text-info text-small">' + Util.htmlEntities(model.get('display_name')) + '</div>' : '') +
                                            (model.get('email') ?
                                            '<div class="text-info text-small">' + Util.htmlEntities(model.get('email')) + '</div>' : '') +
                                            (model.get('last_location') ?
                                            '<div class="text-info text-small"><i class="fas fa-map-marker-alt"></i> ' + Util.htmlEntities(model.get('last_location')) + '</div>' : '') +
                                        '</div>' +
                                    '</td>' +
                                    '<td>' +
                                        '<div class="meteor-primary margin-bottom-4"><div><span style="width:' + percentage + '%;"></span></div></div>' +
                                        data.feedback_total +
                                    '</td>' +
                                '</tr>';
                    }
                });

                if (size < limit) {
                    for (var i = 0; i < (limit - size); i++) {
                        html += '<tr class="empty"><td colspan="2">&nbsp;</td></tr>';
                    }
                }

                if (size > limit) {
                    html += '<tr class="empty"><td colspan="2" align="right"><a href="#" class="primary view-more"><b>View More</b></a></td></tr>';
                }

                html += '</table>';
            }
        } else {
            html += '<div class="text-info text-align-center italic" style="padding:80px 24px;">No feedback submitted with identified user data. You will need to call identify() in your app to identify users. <a target="help" rel="noopener" href="https://support.userback.io/en/articles/9416861-user-database-segments">Find out more</a>.</div>';
        }

        this.$el.html(html);

        return this;
    }
});

export default Top_User_Chart;